<template>
  <div>
    <div class="time"><Icon type="ios-time" color="#FF9D00" size="22" />{{ hour }}：{{ minite }}：{{ second }}</div>
  </div>
</template>
<script>
import util from '@/libs/util'
export default {
  props: {
    duration: {
      type: Number,
      default: null
    }
    // hours:{
    //   type:Number,
    //   default:null
    // },
    // minites:{
    //   type:Number,
    //   default:null
    // },
    // seconds:{
    //   type:Number,
    //   default:null
    // },
  },
  data() {
    return {
      day: 0,
      hour: '00',
      minite: '00',
      second: '00',
      times: 0,
      startTime: 0,
      timer: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$on('childcounttime', res => {
        this.startTime = Date.parse(new Date())
        this.timer = setInterval(() => {
          this.countTime()
        }, 1000)
      })
      this.$on('childEndCount', res => {
        clearInterval(this.timer)
        this.hours = this.hour
        this.minites = this.minite
        this.seconds = this.second
        let message = {
          hour: this.hours,
          minite: this.minites,
          second: this.seconds
        }
        this.$emit('childFn', message)
        // console.log(this.hour, this.minite, this.second)
        // setTimeout(()=>{
        //   this.hour = '00'
        //   this.minite = '00'
        //   this.second = '00'
        // },500)
      })
    },
    countTime() {
      this.second = parseInt(this.second) + 1
      this.second = this.second > 9 ? this.second : '0' + this.second
      if (this.second > 60) {
        this.minite = parseInt(this.minite) + 1
        this.second = '00'
        this.minite = this.minite > 9 ? this.minite : '0' + this.minite
        if (this.minite > 60) {
          this.hour = parseInt(this.hour) + 1
          this.minite = '00'
          this.hour = this.hour > 9 ? this.hour : '0' + this.hour
        }
      }
    }
  },
  mounted() {},
  watch: {},
  destroyed() {
    clearInterval(this.timer)
  },
  computed: {}
}
</script>
<style scoped lang="less">
.time {
  display: inline-flex;
  align-items: center;
  font-size: 20px;
  color: #ff9d00;
  /deep/ .ivu-icon {
    margin-right: 10px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/practise/components/countTime.vue